import { render, staticRenderFns } from "./settingCountryList.vue?vue&type=template&id=4aabb22a"
import script from "./settingCountryList.vue?vue&type=script&lang=js"
export * from "./settingCountryList.vue?vue&type=script&lang=js"
import style0 from "./settingCountryList.vue?vue&type=style&index=0&id=4aabb22a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports